module.exports = __webpack_public_path__ + "img/s3-4.67eaa8a6.jpg";